<template>
  <RouterView />
  <Toast />
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { RouterView } from 'vue-router'
import Toast from 'primevue/toast'
import { useAuthStore } from '@/stores/auth'

const { identifyCustomer } = useAuthStore()

onMounted(() => {
  identifyCustomer()
})
</script>
